module.exports = __webpack_public_path__ + "static/media/business.756a1712.svg";